<template>
  <v-app>
    <v-app-bar app color="secondary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title @click="goToHome()" style="cursor: pointer"
        >SODABA</v-toolbar-title
      >
      <v-spacer></v-spacer>

      <v-menu transition="slide-y-transition" bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-web</v-icon>
            {{ $i18n.locale }}
          </v-btn>
        </template>
        <v-list rounded style="cursor: pointer">
          <v-list-item-group active-class="primary--text">
            <v-list-item v-for="(lang, i) in languages" :key="i">
              <v-list-item-title @click.stop="switchLang(lang.code)">{{
                lang.title
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" bottom temporary>
      <v-list nav shaped>
        <v-list-item-group v-model="group" active-class="primary--text">
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("welcome_m") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/bio">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("biography_m") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/massages">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("massages_m") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission-vision">
            <v-list-item-icon>
              <v-icon>mdi-diamond</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("mission-n-vision_m")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            href="https://rafaellemassotherapie.youcanbook.me/"
            target="_blank"
          >
            <v-list-item-icon>
              <v-icon>mdi-pen</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("booking_m") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://www.facebook.com/studiosodaba"
            target="_blank"
          >
            <v-list-item-icon>
              <v-icon>mdi-telegram</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("social-media_m") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <v-footer fixed padless app height="45" color="secondary">
      <v-col class="text-center white--text">
        <span>&copy;SODABA {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  created() {
    document.title = "SODABA";
    this.setLocale();
  },
  data: () => ({
    drawer: false,
    group: null,
    languages: [
      { title: "EN-English", code: "en" },
      { title: "FR-Français", code: "fr" },
    ],
  }),

  methods: {
    switchLang(code) {
      this.$root.$i18n.locale = code;
    },
    setLocale() {
      const locale = navigator.language.substring(0, 2);
      this.$root.$i18n.locale = locale;
    },
    goToHome() {
      if (this.$route.name != "Landing") {
        this.$router.push("/");
      }
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>
<style scoped>
.v-application {
  font-family: "Marcellus", sans-serif;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s, transform 1s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: transalateX(-30%);
}
</style>
<i18n>
{
  "en":{
    "welcome_m":"Welcome",
    "biography_m":"Biography",
    "massages_m":"Massages",
    "mission-n-vision_m":"Mission & Vision",
    "booking_m":"Booking",
    "social-media_m":"Social Media"
    },
    "fr":{
    "welcome_m":"Bienvenue",
    "biography_m":"Biographie",
    "massages_m":"Les massages",
    "mission-n-vision_m":"La vision de la mission",
    "booking_m":"Réservation",
    "social-media_m":"Des médias sociaux"
    }
  }
</i18n>
